export class Address {
  constructor(application_id: number) {
    this.application_id = application_id;
  }
  application_id: number;
  city: string;
  street: string;
  street_no: string;
  address_suffix: string | null;
  postcode: string;
  is_address_assigned: boolean; // <- UI helper property
}
